import { IFormTemplateDTO, IPaginationDTO } from '@/dtos';
import { generatePagination, get, post } from '../apiWrapper';

export const getAllFormTemplatesAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: IFormTemplateDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const templates = await get<{ data: IFormTemplateDTO[]; count: number }>(
    `/admin/form/templates${pageOptions}`,
  );
  return templates;
};

export const getFormTemplateByIdAPI = async (formTemplateId: string): Promise<IFormTemplateDTO> => {
  const templates = await get<IFormTemplateDTO>(`/admin/form/templates/${formTemplateId}`);
  return templates;
};

export const updateFormTemplateAPI = async (
  formTemplateId: string,
  formTemplate: IFormTemplateDTO,
): Promise<IFormTemplateDTO> => {
  const templates = await post<IFormTemplateDTO>(
    `/admin/form/templates/${formTemplateId}/save`,
    formTemplate,
  );
  return templates;
};
